import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

const SVGComponent = (props) => (
  <Svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#clip0_1298_4124)">
      <Rect width={48} height={48} rx={8} fill="#0059A3" />
      <G clipPath="url(#clip1_1298_4124)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.8692 15H6.04182C4.91483 15 4 15.8583 4 16.9172V31.066C4 32.125 4.91483 33 6.04182 33H41.8692C42.9962 33 43.9188 32.1447 43.9188 31.1089V16.9605C43.9188 15.8591 43.0154 15 41.8692 15ZM31.5903 32.1821H6.04177C5.39477 32.1821 4.87052 31.6742 4.87052 31.0662V16.9174C4.87052 16.3094 5.39432 15.8181 6.04177 15.8181H31.5903V32.1821ZM43.0473 30.3163L41.0963 32.1821H38.3988L43.0473 27.7788V30.3163ZM43.0482 26.3687H41.8729L35.7137 32.1821H33.0208L39.18 26.3687H36.4925L32.4618 30.1787V27.6811L33.837 26.3683H32.4618V15.8176H41.8702C42.5281 15.8176 43.0487 16.3175 43.0487 16.9597L43.0482 26.3687Z"
          fill="#F8931F"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.37485 30.5082C11.204 30.5082 11.9281 29.5856 11.9281 28.0478V26.8847H10.2321V28.3916C10.2321 28.8259 10.0195 29.0608 9.38395 29.0608C8.76799 29.0608 8.5362 28.8255 8.5362 28.3916V19.6C8.5362 19.1657 8.76799 18.9307 9.38395 18.9307C10.0195 18.9307 10.2321 19.1661 10.2321 19.6V21.1146H11.9281V19.9438C11.9281 18.406 11.204 17.4834 9.37485 17.4834C7.56526 17.4834 6.8407 18.406 6.8407 19.9438V28.0482C6.84115 29.586 7.56526 30.5082 9.37485 30.5082Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3773 27.8326H16.1485L16.4761 30.3303H18.1319L16.2453 17.6699H14.2815L12.3948 30.3303H14.0506L14.3773 27.8326ZM15.2625 20.5791L15.9752 26.368H14.5503L15.2625 20.5791Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.4993 24.8178H21.0869C21.7225 24.8178 22.1487 25.081 22.1487 25.8227V28.0842C22.1487 29.1877 22.1843 29.7703 22.6656 30.3302H24.206C23.9555 29.8565 23.8447 29.3326 23.8447 28.7898V25.9316C23.8447 25.0995 23.6991 24.5567 22.6976 24.2853C23.5061 24.1224 23.7069 23.5617 23.7069 22.856V19.2561C23.7069 18.2975 23.012 17.6694 21.9721 17.6694H18.8029V30.3298H20.4988L20.4993 24.8178ZM20.4989 19.1337H21.6259C21.9147 19.1337 22.0114 19.2019 22.0114 19.4733V23.0372C22.0114 23.3086 21.9147 23.3969 21.6259 23.3969H20.4989V19.1337Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.1444 30.5082C28.7619 30.5082 29.5736 29.5676 29.5736 28.3012V26.5284C29.5736 25.7867 29.3624 25.226 28.881 24.6832L26.8953 22.3497C26.5682 21.9699 26.4112 21.6441 26.4112 21.1013V19.6C26.4112 19.1657 26.648 18.9307 27.1673 18.9307C27.6869 18.9307 27.9238 19.1661 27.9238 19.6V21.287H29.6193V19.6904C29.6193 18.424 28.7943 17.4834 27.1768 17.4834C25.5598 17.4834 24.7152 18.424 24.7152 19.6904V21.4632C24.7152 22.2048 24.9306 22.7656 25.3928 23.3084L27.4187 25.6418C27.7463 26.0217 27.9238 26.3475 27.9238 26.8903V28.3916C27.9238 28.8259 27.6641 29.0608 27.1444 29.0608C26.6247 29.0608 26.3656 28.8255 26.3656 28.3916V26.7123H24.7157V28.3007C24.7152 29.5676 25.527 30.5082 27.1444 30.5082Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.1459 21.2103C37.5351 20.4597 37.75 19.9207 37.75 19.3141C37.75 18.1399 37.2075 17.667 36.3675 17.667C35.6918 17.667 34.985 18.1004 34.985 19.3493H35.8761C35.8761 18.7465 36.0294 18.4271 36.3776 18.4271C36.7362 18.4271 36.8589 18.7358 36.8589 19.3514C36.8589 19.7746 36.8033 20.1506 36.373 20.9591L34.9353 23.7595V24.5166H37.777V23.7415H35.8456L37.1459 21.2103Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.1144 17.7561H39.2762L37.5479 22.1432V22.8805H39.2434V24.5169H40.1144V22.8805H40.5725V22.1054H40.1144V17.7561ZM39.2438 22.1057H38.3646L39.2438 19.8532V22.1057Z"
          fill="white"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="clip0_1298_4124">
        <Rect width={48} height={48} rx={8} fill="white" />
      </ClipPath>
      <ClipPath id="clip1_1298_4124">
        <Rect width={40} height={18} fill="white" transform="translate(4 15)" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default SVGComponent
